export default "__VITE_ASSET__BriE__rg__"